import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import Radium from 'radium';
import { connect } from 'react-redux';
import * as actions from './actions';
import { semanticColors } from '../../../../Globals/styles';
import {dateToString} from '../../../../Util/dateTime';

import {
	dailyReportToggleEditSignature
} from '../actions'
/* read the signature_pad docs here:
*  https://github.com/szimek/signature_pad */
import SignaturePad from 'signature_pad/dist/signature_pad';

class Signature extends Component{
	constructor(props) {
    super(props);
    this.state = {
			name: null,
			todaysDate: new Date()
    }
  }

  componentDidMount = () => {
		this._signaturePad = new SignaturePad(this.refs.canvas);
  };
  reset = () => {
		this.props.dispatch(dailyReportToggleEditSignature(false))
  };
  save = () => {
		const { dispatch, currentDailyReportId, isLoading } = this.props;
    //if loading dont save again
    if(isLoading) return;

		var formData = {
			signature: this._signaturePad.toDataURL(),
			name: this.state.name,
			id: currentDailyReportId
		}
		dispatch(actions.saveSignature(formData));
	};
  render()  {
    const { isLoading } = this.props;
    return (

        <div style={styles.container}>
          <h3>Underskrift</h3>
            <div style={styles.dateContainer}>
             {dateToString(this.state.todaysDate)}
            </div>
            <div style={styles.imageContainer}>
              <canvas
              ref="canvas"
              height="100"
              width="380"
              style={styles.canvas}
              />
              <div style={styles.nameContainer}>
              <input
              style={styles.input}
              placeholder="Skriv navn..."
              value={this.state.name}
              onChange={evt=>this.setState({name: evt.target.value})}
            />
          </div>
        </div>

				<div style={styles.buttonContainer}>
          <div
            className="waves-btn"
            style={styles.iconsContainer}
            onClick={this.save}>
            <i
              className={isLoading ? "fa fa-spinner fa-spin" : "fa fa-floppy-o"}
              aria-hidden="true"
              style={styles.icon}
            ></i>
            <div style={styles.label}>{isLoading ? "Gemmer..." : "Gem"}</div>
          </div>
          <div style={styles.divider}></div>
          <div
            className="waves-btn"
            style={styles.iconsContainer}
            onClick={this.reset}>
            <i
              className="fa fa-undo"
              aria-hidden="true"
              style={styles.icon}
            ></i>
            <div style={styles.label}>Fortryd</div>
          </div>
				</div>

      </div>
			);
  }
}

var styles = {
	canvas: {
		backgroundColor: '#fff'
	},
	container: {
    height: '225px',
    width: '100%',
    position: 'relative'
  },
  dateContainer: {
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    float: 'left',
    width: '30%',
    position: 'absolute',
    top: '95px'
  },
  imageContainer: {
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    float: 'right',
    width: '66%',
    position: 'relative'
  },
  image: {
    width: '380px',
    height: '100px'
  },
  nameContainer: {
    bottom: '-45px',
    position: 'absolute',
    width: '100%'
  },
  input: {
    width: '100%'
  },
  buttonContainer: {
    position: 'absolute',
    right: '0',
    bottom: '0'
  },
  iconsContainer: {
    display: 'inline-block',
    textAlign: 'center',
    float: 'right',
    width: '80px',
    height: '50px',
    padding: '5px',
    cursor: 'pointer'
  },
  label: {
    fontSize: '12px',
    marginTop: '4px',
    fontWeight: '600'
  },
  icon: {
    display: 'block',
    fontSize: '22px'
  },
  divider: {
    display: 'inline-block',
    float: 'right',
    width: '1px',
    height: '30px',
    marginTop : '10px',
    backgroundColor: semanticColors.mainBackground
  }
}

const selectProps = state => {
  return {
    ...state.dailyReportSignatureReducer
  };
}
  Signature.propTypes = {
    dispatch: PropTypes.func.isRequired,
    signature: PropTypes.shape({
      dateOfSignature: PropTypes.object.isRequired,
      signature: PropTypes.string.isRequired,
      name: PropTypes.string
    }),
    currentDailyReportId: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired
  };

export default connect(selectProps)(Signature);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Signature/index.jsx